import { Button, ButtonGroup } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { useAppContext } from "../../context";
import { checkRole, reducerFn } from "../../helper";
import { useSelectRowsCtx } from "../shared/SelectRow";
import AmazonIdeaTemplateDelete from "./actions/amazon-idea-template-delete";

export default function AmazonIdeaTemplateBulkAction() {
    const { currentUser } = useAppContext();
    const { isChannelLeader, isChannelIdea, isChannelSeller, isSeller } =
        checkRole(currentUser);

    const leader =
        isChannelSeller || isChannelLeader || isChannelIdea || isSeller;

    const [state, setState] = useReducer(reducerFn, {
        open: false,
        action: null,
    });

    const { ids, onCompleted } = useSelectRowsCtx();

    const toggleShowModal = useCallback((action) => {
        setState((p) => ({ ...p, open: !p.open, action }));
    }, []);

    const props = {
        open: state.open,
        toggleShowModal,
        onClose: toggleShowModal,
        onCompleted,
        ids,
    };

    const actionsMarkup = {
        delete: <AmazonIdeaTemplateDelete {...props} />,
    };

    return (
        <>
            <ButtonGroup segmented>
                {leader ? (
                    <Button
                        children="Delete Template"
                        onClick={() => toggleShowModal("delete")}
                        disclosure
                    />
                ) : null}
            </ButtonGroup>
            {actionsMarkup[state.action] || null}
        </>
    );
}
